export default __webpack_public_path__ + "static/media/ic-alert-circle.2cb71f6b.svg";